import { $axios } from "@/config/axios";

export default {
  // pgs will be repeated in the payload
  fetchStStatsByPondIdAndStId(pondId, stId, params) {
    return $axios.get(`/ponds/${pondId}/shrimp-talks/${stId}/statistics-data`, {
      params,
    });
  },
  fetchStDetailsByPondId(pondId, params) {
    return $axios.get(`/ponds/${pondId}/shrimp-talks`, {
      params,
    });
  },
  addPondMotherToShrimpTalk(stId, params) {
    return $axios.post(`ponds/shrimp-talks/${stId}/pond-mothers`, params);
  },
  removePondMotherFromShrimpTalk(stId, params) {
    console.log(params);
    return $axios.delete(`ponds/shrimp-talks/${stId}/pond-mothers`, {
      data: params,
    });
  },
};
